import {
    CREATE_BILL_PAYMENT_DETAILS_REQUEST,
    CREATE_BILL_PAYMENT_DETAILS_SUCCESS,
    CREATE_BILL_PAYMENT_DETAILS_FAILURE,
    DELETE_BILL_PAYMENT_DETAILS_REQUEST,
    DELETE_BILL_PAYMENT_DETAILS_SUCCESS,
    DELETE_BILL_PAYMENT_DETAILS_FAILURE,
    FETCH_SINGLE_BILL_PAYMENT_DETAILS_REQUEST,
    FETCH_SINGLE_BILL_PAYMENT_DETAILS_SUCCESS,
    FETCH_SINGLE_BILL_PAYMENT_DETAILS_FAILURE,
    FETCH_BILL_PAYMENT_DETAILS_REQUEST,
    FETCH_BILL_PAYMENT_DETAILS_SUCCESS,
    FETCH_BILL_PAYMENT_DETAILS_FAILURE,
    UPDATE_BILL_PAYMENT_DETAILS_REQUEST,
    UPDATE_BILL_PAYMENT_DETAILS_SUCCESS,
    UPDATE_BILL_PAYMENT_DETAILS_FAILURE,
    RESET_BILL_PAYMENT_DETAILS_INFO,
    CREATE_BILL_PAYMENT_DETAILS_FORM,
    UPDATE_BILL_PAYMENT_DETAILS_FORM,
    FETCH_BILL_PAYMENT_DETAILS_WITHOUT_ID_SUCCESS,
    RESET_BILL_PAYMENT_DETAILS
} from './billPaymentDetails.actionType';

export const BILL_PAYMENT_DETAILS = 'billPaymentDetails';

let initialState = {
    loading: false,
    billPaymentDetails: [],
    billPaymentDetailsWithoutId: [],
    billPaymentDetailsform: {
        fldOtherPlusValue: 0,
        fldBalanceAmount: 0
    },
    selectedState: {},
    errorMessage: ''
};

export let billPaymentDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_BILL_PAYMENT_DETAILS_REQUEST:
        case CREATE_BILL_PAYMENT_DETAILS_REQUEST:
        case UPDATE_BILL_PAYMENT_DETAILS_REQUEST:
        case FETCH_SINGLE_BILL_PAYMENT_DETAILS_REQUEST:
        case DELETE_BILL_PAYMENT_DETAILS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_BILL_PAYMENT_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                billPaymentDetails: updatePayload
            };
        case FETCH_BILL_PAYMENT_DETAILS_WITHOUT_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                billPaymentDetailsWithoutId: updatePayload
            };
        case CREATE_BILL_PAYMENT_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                billPaymentDetailsform: {
                    fldOtherPlusValue: 0,
                    fldBalanceAmount: 0
                }
            };
        case UPDATE_BILL_PAYMENT_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                billPaymentDetailsform: {
                    fldOtherPlusValue: 0,
                    fldBalanceAmount: 0
                }
            };
        case FETCH_SINGLE_BILL_PAYMENT_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                billPaymentDetailsform: updatePayload
            };
        case DELETE_BILL_PAYMENT_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                billPaymentDetailsform: {
                    fldOtherPlusValue: 0,
                    fldBalanceAmount: 0
                }
            };
        case RESET_BILL_PAYMENT_DETAILS_INFO:
            return {
                ...state,
                billPaymentDetailsform: {
                    fldOtherPlusValue: 0,
                    fldBalanceAmount: 0
                }
            };
        case CREATE_BILL_PAYMENT_DETAILS_FORM:
        case UPDATE_BILL_PAYMENT_DETAILS_FORM:
            return {
                ...state,
                loading: false,
                billPaymentDetailsform: {
                    ...state.billPaymentDetailsform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_BILL_PAYMENT_DETAILS_FAILURE:
        case CREATE_BILL_PAYMENT_DETAILS_FAILURE:
        case UPDATE_BILL_PAYMENT_DETAILS_FAILURE:
        case FETCH_SINGLE_BILL_PAYMENT_DETAILS_FAILURE:
        case DELETE_BILL_PAYMENT_DETAILS_FAILURE:
            return {
                ...state,
                loading: false
            };

        case RESET_BILL_PAYMENT_DETAILS:
            return {
                loading: false,
                billPaymentDetails: [],
                billPaymentDetailsWithoutId: [],
                billPaymentDetailsform: {
                    fldOtherPlusValue: 0,
                    fldBalanceAmount: 0
                },
                selectedState: {},
                errorMessage: ''
            };
        default:
            return state;
    }
};
